module.exports = __webpack_public_path__ + "static/media/graduated.6c946d24.png";